/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit NoAppointmentAvailable/view.blocks to change it.
import "DesignSystem/Fonts/Inter-300.css"
import Contactofficegraphic01 from 'DesignSystem/Svgs/Contactofficegraphic01/index'
import React from 'react'
import styles from './view.module.css'
import viewPath from './viewPath.js'



/**
 * @type {(
 *  props: {
 *    [x: string]: any,
 *    children?: React.ReactNode,
 *    viewPath: typeof viewPath
 *  }) => React.JSX.Element}
 */
export default function NoAppointmentAvailable({
  children,
  viewPath = "/App/Form/Data/ProvideData/Location/Content/NoAppointmentAvailable"
  
}) {
  return (<React.Fragment
>
<div
  data-testid="NoAppointmentAvailable.Vertical"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical}`}
>
<Contactofficegraphic01
  viewPath={`${viewPath}/Contactofficegraphic01`}
 width={360}
 height={200}
/>
<div
  data-testid="NoAppointmentAvailable.Vertical:1"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical1}`}
>
<span
  data-testid="NoAppointmentAvailable.Text"
  data-view-path={viewPath}
 className={`views-text ${styles.Text}`}
>
Apologies, no appointments are available at the moment.
</span>
<span
  data-testid="NoAppointmentAvailable.Text:1"
  data-view-path={viewPath}
 className={`views-text ${styles.Text1}`}
>
Please, contact our office directly.
</span>
</div>
</div>
{children}
</React.Fragment>)
}